//React
import React from "react";
import {
  Link,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myQaQuestionAction from '../action/myQaQuestionAction';
import * as partnerOperationAction from '../action/partnerOperationAction';
//Add

//Material-ui
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Divider from '@material-ui/core/Divider';
//Part
import PartUserName from './PartUserName';
import PartUserMainImg from './PartUserMainImg';
import PartPagingNextPrev from './PartPagingNextPrev';
//Icon
import CloseIcon from '@material-ui/icons/Close';

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      list: [],
      isListNext: false,
      page: 1,
  	}
  }


  componentDidUpdate(prevProps, prevState) {
    if (this.props.open !== prevProps.open && this.props.open === true) {
      this._listGet(1);
    }
  }

  _listGet(page) {
    this.props.myQaQuestionStatisticsUserGet(this.props.qaId, this.props.answerComment, page, (data) => {
      this.setState({
        list: data.list,
        isListNext: data.isListNext,
        page: page,
      });
      document.getElementById('my_qa_question_statistics_user_list_block').scrollTo(0, 0);
    })
  }

  _renderList(value, index, arr) {
    return (
      <div key={index}>
        <div style={{padding:'3px'}}>
          {
            (this.props.my.profile.userdata_opposite_sex === value.userdata_sex) ? (
              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                  justifyContent:'space-between',
                }}
              >
                <div style={{margin:'3px'}}>
                  <Link
                    to={{ pathname: '/partner/' + value.userdata_id_code}}
                  >
                    <PartUserMainImg
                      mainImg={value.userdata_mainImg}
                      width={'40px'}
                      height={'40px'}
                      radius={'50%'}
                    />
                  </Link>
                </div>
                <div style={{flex:1}}>
                  <div style={{fontSize:'0.8em', color:'#666'}}>
                    {value.date}
                  </div>
                  <Link
                    to={{ pathname: '/partner/' + value.userdata_id_code}}
                  >
                    <PartUserName
                      data={{
                        name: value.userdata_name,
                        sex: value.userdata_sex,
                        size: '1.2em',
                      }}
                    />
                  </Link>
                  <div>
                    {value.userdata_age}才 {value.userdata_prof_region}
                  </div>
                </div>
              </div>
            ): (
              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                  justifyContent:'space-between',
                }}
              >
                <div style={{margin:'3px'}}>
                  <PartUserMainImg
                    mainImg={{
                      bool:true,
              				quit:false,
                      stop:false,
              				sex:value.userdata_sex,
              				src:null,

                    }}
                    width={'40px'}
                    height={'40px'}
                    radius={'50%'}
                  />
                </div>
                <div style={{flex:1}}>
                  <PartUserName
                    data={{
                      name: (value.userdata_sex === 'men') ? '男性の回答': '女性の回答',
                      sex: value.userdata_sex,
                      size: '1.2em',
                    }}
                  />

                  <div>
                    {value.count}件
                  </div>
                </div>
              </div>
            )
          }

        </div>
        {
          (arr.length - 1 > index) &&
          <Divider />
        }
      </div>
    )
  }

	render() {
		return (
      <Dialog
        open={this.props.open}
        onClose={
          () => {
            this.setState({list:[]});
            this.props.close();
          }
        }
      >
        <div
          style={{
            width:'100%',
            minWidth:'240px',
          }}
        >
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              textAlign:'center',
              alignItems:'center',
              justifyContent:'space-between',
              background:'#FFF',
            }}
          >
            <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
              Q&Aに回答した会員
            </div>

            <div>
              <IconButton
                onClick={
                  () => {
                    this.setState({list:[]});
                    this.props.close();
                  }
                }
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>

          <div style={{margin:'10px'}}>
              「{this.props.answerComment}」
          </div>
        </div>
        <div
          id='my_qa_question_statistics_user_list_block'
          style={{
            overflowY:'auto',
            WebkitOverflowScrolling: 'touch',
          }}
        >
        {
          (this.state.list.length > 0) ? (
            this.state.list.map((value, index, arr) =>
              this._renderList(value, index, arr)
            )
          ) : (
            <div style={{margin:'10px'}}>Q&Aに回答した会員はみつかりませんでした</div>
          )
        }
        </div>
        <div style={{margin:'5px'}}>
          <PartPagingNextPrev
            page={this.state.page}
            isNext={this.state.isListNext}
            onClick={ (e) => this._listGet(e) }
          />
        </div>

      </Dialog>
		)
	}
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myQaQuestionAction,
    ...partnerOperationAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
